// extracted by mini-css-extract-plugin
export var table = "_xy-0";